export const appDbPath = 'app/db';
export const mainPath = 'main';
export const pagePath = 'page';
export const homePath = 'home';
export const userPath = 'user';
export const logsPath = 'logs';
export const chartsPath = 'charts';
export const loginPath = 'login';
export const dashboardPath = 'dashboard';
export const configPath = 'config';
export const objectsPath = 'objects';
export const ssoPath = 'sso';
export const typicalconfigPath = 'typicalconfig';
export const defaultDashboardPath = 'defaultdashboard';
export const mainPageHomePath = `${mainPath}/${pagePath}/${homePath}`;
